import i18n from '@/plugins/i18n';

/* eslint-disable import/prefer-default-export */
export const FAVOURITE_HEADER = [
  {
    text: i18n.t('components.favourites.table.name'),
    align: 'left',
    sortable: false,
    value: 'alias',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.favourites.table.address'),
    align: 'left',
    sortable: false,
    value: 'fullAddressText',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.favourites.table.favourite_pickup'),
    align: 'left',
    sortable: false,
    value: 'suggestForPickupAddress',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.favourites.table.favourite_dropoff'),
    align: 'left',
    sortable: false,
    value: 'suggestForDestinationAddress',
    class: 'text-uppercase',
  },
  {
    align: 'right',
    sortable: false,
    value: 'actions',
    class: 'text-uppercase',
  },
];
